import React, { useRef, useEffect } from 'react';

const JumbleModal = (props: { showModal: boolean; closeModal: () => void; modalSections: (() => JSX.Element)[] }) => {
  const { showModal, closeModal, modalSections } = props;

  const modalRef = useRef<HTMLDivElement>(null);

  // close modal when clicking outside of it
  useEffect(() => {
    function handleClickOutside(event: any) {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        closeModal();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);

    // Clean up the listener on component unmount
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [closeModal]);

  // scroll to top of modal when it opens
  useEffect(() => {
    const modal = document.querySelector('.tw-modal-content');
    if (modal && showModal) {
      modal.scrollTop = 0;
    }
  }, [showModal]);

  return (
    <div
      className={`tw-fixed tw-inset-0 tw-w-full tw-h-full tw-bg-gradient-to-b tw-from-primary-300/30 tw-to-secondary-400/30 tw-backdrop-blur-md tw-flex tw-flex-col tw-justify-center tw-items-center tw-z-50 tw-transition-opacity tw-duration-400 ${
        showModal ? 'tw-opacity-100 tw-visible' : 'tw-opacity-0 tw-invisible'
      }`}
    >
      <div
        className="tw-flex tw-flex-col tw-modal-content tw-mt-16 tw-bg-transparent tw-p-5 tw-rounded-lg lg:tw-w-[40%] tw-overflow-y-auto tw-gap-4 tw-scrollbar-hide"
        ref={modalRef}
      >
        {showModal &&
          modalSections.map((section, index) => {
            return (
              <div key={`modal-section-${index}`} className="tw-bg-neutral-50 tw-rounded-2xl tw-p-6">
                {section()}
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default JumbleModal;
